<template>
  <section>
    <b-col v-if="heatMapLoading" class="py-4">
      <b-progress-bar :value="100" :max="100" variant="success" striped :animated="true">
        Caricamento dati in corso
      </b-progress-bar>
    </b-col>

    <b-row v-if="charts.length > 1 && !reportMode" class="py-4">
      <b-col md="6">
        <b-input-group prepend="Min/Max">
          <b-select v-model="abs_min_max">
            <option :value="true">Assoluti</option>
            <option :value="false">Relativi</option>
          </b-select>
        </b-input-group>
      </b-col>
    </b-row>

    <div v-for="(chart, index) in charts" :key="index" id="hcc_1">
      <b-row style="padding-bottom: 10px" v-if="!reportMode">
        <b-col>
          Min: <input type="text" v-model="manualMin" /> Max: <input type="text" v-model="manualMax" />
          <b-btn @click="reload()">
            <font-awesome-icon icon="sync" />
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5 class="py-3">{{ chart.name }}</h5>
          <table class="table" id="carpet">
            <tr>
              <td>
                <div style="height: 500px" :ref="chart.chartId" v-bind:id="chart.chartId"></div>
              </td>
              <td style="width: 120px" class="meter-bar">
                <img id="meter" src="/static/heatmap.png" alt="heat meter" />
                <span class="meter-top">{{ chart.max }} [{{ chart.mu }}]</span>
                <span class="meter-med">{{ ((chart.max - chart.min) / 2).toFixed(0) }} [{{ chart.mu }}]</span>
                <span class="meter-bot">{{ chart.min }} [{{ chart.mu }}]</span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <!-- {{chart.chartId}}
       -->
    </div>
  </section>
</template>

<script>
import NeedUpdateMixin from "../../NeedUpdateMixin";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
var moment = require("moment");
import { makeid } from "../../helpers";
import { startRender, finishRender } from "../../../../helpers/printReady";

export default {
  name: "PieChart",
  props: {
    filter: {
      type: Object,
      required: true,
    },
    reportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mixins: [NeedUpdateMixin],

  created() {
    this.reload();
  },

  beforeDestroy() {
    this.unload();
  },

  data() {
    return {
      charts: [],
      heatMapLoading: false,
      abs_min_max: true,
      min_max: {},
      manualMin: "",
      manualMax: "",
      apiData: null,
    };
  },

  watch: {
    filter() {
      this.heatMapLoading = true;
      this.apiData = null;
      _.debounce(this.reload, 10)();
    },
    abs_min_max() {
      this.reload();
    },
  },

  methods: {
    async reload() {
      this.heatMapLoading = true;
      this.$store.commit("loading");
      // this.unload();
      this.createData();
    },

    async createHeatChart(chartItem, chartIndex) {
      let invertedData = [];
      for (var i = chartItem.data.length - 1; i >= 0; i--) {
        invertedData.push(chartItem.data[i]);
      }

      var chart = am4core.create(chartItem.chartId, am4charts.XYChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.preloader.progress = 0.5;
      chart.data = invertedData;
      chart.maskBullets = false;
      chart.language.locale = am4lang_it_IT;
      chart.numberFormatter.numberFormat = "#.0";
      if (this.reportMode) {
        chart.fontSize = 10;
      }

      var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      xAxis.renderer.inversed = true;
      xAxis.renderer.labels.template.rotation = -45;
      xAxis.renderer.labels.template.horizontalCenter = "right";
      xAxis.renderer.labels.template.verticalCenter = "middle";
      var yAxis = chart.yAxes.push(new am4charts.CategoryAxis());

      xAxis.dataFields.category = "x";
      yAxis.dataFields.category = "name";

      xAxis.renderer.grid.template.disabled = true;
      xAxis.renderer.minGridDistance = 40;

      yAxis.renderer.grid.template.disabled = true;
      yAxis.renderer.inversed = true;
      yAxis.renderer.minGridDistance = 30;

      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryX = "x";
      series.dataFields.categoryY = "name";
      series.dataFields.value = "y";
      series.sequencedInterpolation = true;
      series.defaultState.transitionDuration = 3000;
      series.tooltip.getFillFromObject = false;
      series.tooltip.autoTextColor = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series.tooltip.label.fill = am4core.color("#000");

      var bgColor = new am4core.InterfaceColorSet().getFor("background");

      var columnTemplate = series.columns.template;
      // series.tooltip.label.propertyFields.fill = am4core.color('#FFFFFF');
      columnTemplate.strokeWidth = 1;
      columnTemplate.strokeOpacity = 0.2;
      columnTemplate.stroke = am4core.color(bgColor);
      columnTemplate.tooltipText = "{name}, {x}: {y}";
      columnTemplate.width = am4core.percent(100);
      columnTemplate.height = am4core.percent(100);

      series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        // min: am4core.color("#000093"),
        // max: am4core.color("#FF0000")
      });

      series.tooltip.label.adapter.add("text", function (text, target) {
        try {
          let context = target.dataItem.dataContext;
          return `${context.name} ${context.x} ${context.y == null ? "--" : number(context.y).tofixed(2)}`;
        } catch (error) {
          return text;
        }
      });

      series.columns.template.column.adapter.add("fill", function (fill, target) {
        if (target.dataItem) {
          let value = target.dataItem.value;
          let color;
          chartItem.plotOptions.forEach((ele) => {
            if (value <= ele.to && value >= ele.from) {
              color = ele.color;
            }
          });
          if (!color) {
            return am4core.color("#D3D3D3");
          }
          return am4core.color(color);
        }
        return fill;
      });

      this.charts[chartIndex].chart = chart;
      this.heatMapLoading = false;
    },

    async createData() {
      try {
        let apiData = this.apiData;

        if (!apiData) {
          apiData = await this.$store.dispatch("charts/get", this.filter);
          this.apiData = apiData;
        }

        let data = apiData;

        this.charts = [];

        let count = data.columns.length + data.parameters.length;

        for (let chartIndex = 1; chartIndex < count; chartIndex++) {
          var mu = data.mus[chartIndex - 1];
          if (!this.min_max[mu]) {
            this.min_max[mu] = { min: null, max: 0 };
          }
          let chart = {};
          let series = [];
          for (let h = 0; h < 24; h++) {
            series.push({
              name: _.padStart(h.toString(), 2, "0"),
              data: [],
            });
          }

          var mu = data.mus[chartIndex - 1];

          chart.min = null;
          chart.max = 0;

          data.values.forEach((v) => {
            let value1 = v[chartIndex] != undefined ? v[chartIndex] : null;
            this.min_max[mu].max = Math.max(this.min_max[mu].max, value1);
            if (value1 != null && value1 != undefined) {
              this.min_max[mu].min = this.min_max[mu].min == null ? value1 : Math.min(this.min_max[mu].min, value1);
            }
            let date = moment.utc(v[0], "YYYY-MM-DD HH:mm:ss", "it", true);

            let h = parseInt(date.format("HH"));

            let value = v[chartIndex] != undefined ? v[chartIndex] : null;

            let inSerie = series[h].data.find((e) => e.x == date.format("ddd D MMM"));
            if (!inSerie) {
              series[h].data.push({
                x: date.format("ddd D MMM"),
                y: v[chartIndex],
              });
            } else {
              if (inSerie.x == null && value != null) inSerie.x = value;
            }

            if (value != null) {
              chart.max = Math.max(chart.max, value);
              chart.min = chart.min == null ? value : Math.min(chart.min, value);
            }
          });
          chart.plotOptions = [];
          let colors = [
            "#00009a",
            "#0200ad",
            "#0000bc",
            "#0000cf",
            "#0000de",
            "#0401ee",
            "#0000fe",
            "#000fff",
            "#001ffe",
            "#022eff",
            "#003fff",
            "#004eff",
            "#005ffe",
            "#0071fe",
            "#0185fd",
            "#0298ff",
            "#02acff",
            "#00bfff",
            "#03cfff",
            "#02dfff",
            "#00effc",
            "#01ffff",
            "#0fffee",
            "#1fffdd",
            "#30fece",
            "#3dffbf",
            "#4ffeaf",
            "#5ffe9d",
            "#71fe8e",
            "#85fe77",
            "#97fe67",
            "#aaff50",
            "#beff41",
            "#cfff2e",
            "#e0ff1f",
            "#eeff0b",
            "#ffff01",
            "#fdef01",
            "#ffdf00",
            "#ffcf00",
            "#fcbf00",
            "#ffaf00",
            "#fea002",
            "#ff8f00",
            "#fe8000",
            "#fd6802",
            "#fc5501",
            "#ff4000",
            "#fe2f02",
            "#ff1e00",
            "#ff0e02",
            "#fe0000",
            "#ec0100",
            "#de0101",
            "#cf0000",
            "#be0002",
            "#ae0001",
            "#a00000",
            "#8e0100",
            "#790304",
          ];
          let min = this.abs_min_max ? this.min_max[mu].min : chart.min;
          let max = this.abs_min_max ? this.min_max[mu].max : chart.max;

          if (this.manualMin.length > 0) {
            min = parseInt(this.manualMin);
          }

          if (this.manualMax.length > 0) {
            max = parseInt(this.manualMax);
          }

          var split = (max - min) / colors.length;
          chart.min = min.toFixed(2);
          chart.max = max.toFixed(2);

          for (let i = 0; i < colors.length; i++) {
            chart.plotOptions.push({
              from: i * split + min,
              to: (i + 1) * split + min,
              color: colors[i],
              // name: (i * split + min).toFixed(0) + " - " + ((i + 1) * split + min).toFixed(0)
            });
          }

          let chartData = [];

          series.forEach((ele, i) => {
            ele.data.forEach((dataEle) => {
              dataEle.name = ele.name;
              dataEle.y = dataEle.y ? dataEle.y : null;
              chartData.push(dataEle);
            });
          });

          chart.chartId = makeid();
          chart.chart = undefined;
          chart.data = chartData;
          chart.mu = data.mus[chartIndex - 1];
          chart.name = data.columns[chartIndex];
          this.charts.push(chart);
        }
        setTimeout(() => {
          this.charts.forEach((chartItem, chartIndex) => {
            this.createHeatChart(chartItem, chartIndex);
          });
          this.$store.commit("stopLoading");
        }, 100);
      } catch (error) {
        console.log(error.message);
      }
    },

    unload() {
      this.charts.forEach((chart) => {
        chart.chart.dispose();
      });
      this.charts = [];
      this.apiData = null;
      (this.abs_min_max = true), (this.min_max = {});
      this.manualMin = "";
      this.manualMax = "";
    },
  },

  computed: {
    getCharts() {
      return this.charts;
    },
  },
};
</script>

<style>
#meter {
  height: 428px;
  top: 16px;
  position: absolute;
}
table#carpet td {
  padding: 0;
}
.meter-bar {
  position: relative;
}
.meter-bar span {
  position: absolute;
  left: 20px;
  font-size: 12px;
}
.meter-bar span.meter-top {
  top: 46px;
}
.meter-bar span.meter-med {
  top: 226px;
}
.meter-bar span.meter-bot {
  top: 411px;
}
.carpet-chart-container .apexcharts-xaxis text {
  opacity: 0;
}
.carpet-chart-container .apexcharts-xaxis text:nth-child(7n) {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Carpet.vue